import React from "react";
import "./InputBox.scss";

import { useState } from "react";
const InputBox = ({
	type = "text",
	name = "",
	placeholder = "Enter text...",
	value = "",
	min,
	max,
	step,
	handleChange,
	disabled = false,
	readOnly = false,
	decimalAllowed = true,
}) => {
	const [error, setError] = useState("");
	const [isValid, setIsValid] = useState(true);

	// URL validation function
	const isValidUrl = (urlString) => {
		if (!urlString || urlString.trim() === "") {
			return true; // Empty URL is considered valid (optional field)
		}

		// First, check basic URL pattern
		const urlPattern = /^https?:\/\/.+\..+/;
		if (!urlPattern.test(urlString)) {
			return false;
		}

		try {
			const url = new URL(urlString);

			// Check protocol
			if (url.protocol !== "http:" && url.protocol !== "https:") {
				return false;
			}

			// Check if hostname exists and is valid
			if (!url.hostname || url.hostname.length === 0) {
				return false;
			}

			// Check if hostname contains at least one dot (for domain.tld)
			if (!url.hostname.includes(".")) {
				return false;
			}

			// Check if hostname is not just dots
			if (url.hostname.replace(/\./g, "").length === 0) {
				return false;
			}

			return true;
		} catch (_) {
			return false;
		}
	};

	// Number validation function
	const validateNumber = (value) => {
		if (value === "" || value === null || value === undefined) {
			return { isValid: true, message: "" };
		}

		if (!decimalAllowed && value.includes(".")) {
			return {
				isValid: false,
				message: "Decimal values are not allowed.",
			};
		}

		const numericValue = parseFloat(value);
		if (isNaN(numericValue)) {
			return { isValid: false, message: "Please enter a valid number." };
		}

		if (min !== undefined && numericValue < min) {
			return {
				isValid: false,
				message: `Value should not be less than ${min}.`,
			};
		}

		if (max !== undefined && numericValue > max) {
			return {
				isValid: false,
				message: `Value should not be greater than ${max}.`,
			};
		}

		return { isValid: true, message: "" };
	};

	const onChange = (e) => {
		const newValue = e.target.value;
		let validationMessage = "";
		let valueIsValid = true;

		// Validate based on input type
		if (type === "number") {
			const numberValidation = validateNumber(newValue);
			validationMessage = numberValidation.message;
			valueIsValid = numberValidation.isValid;
		} else if (type === "url") {
			if (!isValidUrl(newValue)) {
				validationMessage =
					"Please enter a valid URL (http:// or https://).";
				valueIsValid = false;
			}
		}

		// Update error state
		setError(validationMessage);
		setIsValid(valueIsValid);

		// Always call handleChange to allow typing, but pass validation status
		// This allows the user to continue typing while showing validation errors
		if (handleChange) {
			handleChange(name, newValue, valueIsValid);
		}
	};

	const inputProps = {
		type,
		name,
		value,
		onChange,
		placeholder,
		disabled,
		readOnly,
		className: `${type === "number" ? "number-input" : "text-input"}${
			!isValid ? " input-error" : ""
		}`,
	};

	if (type === "number") {
		if (min !== undefined) inputProps.min = min;
		if (max !== undefined) inputProps.max = max;
		if (step !== undefined) inputProps.step = step;
	}

	return (
		<div
			className="text-input-wrapper"
			style={type === "number" ? { width: "100px" } : { width: "375px" }}
		>
			<input {...inputProps} />
			{error && (
				<div
					className="text-danger"
					style={{ fontSize: "0.875rem", marginTop: "0.25rem" }}
				>
					{error}
				</div>
			)}
		</div>
	);
};

export default InputBox;
